import { render, staticRenderFns } from "./Coding.vue?vue&type=template&id=5aaccf18&scoped=true"
import script from "./Coding.vue?vue&type=script&lang=ts"
export * from "./Coding.vue?vue&type=script&lang=ts"
import style0 from "./Coding.vue?vue&type=style&index=0&id=5aaccf18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aaccf18",
  null
  
)

export default component.exports